<ol-list-widget
  [title]="title"
  [layoutConfig]="{ itemsPerRow: 1, rowGap: 24, columnGap: 24 }"
  [widgets]="videoPreviewData"
>
  <ng-template #itemTemplate let-item>
    <ol-video-preview-widget [widget]="item"/>
  </ng-template>
</ol-list-widget>